<!-- start of accordion Classification-->

<div class="accordion my-2" *ngIf="AccordionName != null && AccordionName !=''  ">
  <div class="accordion-item" [dir]="biService.getDir() ? 'rtl': 'ltr'">
    <!--accordion header -->
    <div class="accordion-header" id="{{AccordionName}}Heading">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
        [attr.data-bs-target]="'#collape'+AccordionName" aria-expanded="false"
        [attr.aria-controls]="'collape'+AccordionName">
        <h5 class="title">{{AccordionName | translate}}</h5>
        <hr>
      </button>
    </div>
    <!--accordion body -->
    <div id="collape{{AccordionName}}" class="accordion-collapse collapse"
      [attr.aria-labelledby]="AccordionName+'Heading'" data-bs-parent="#accordion">
      <div class="accordion-body ">
        <ng-container *ngTemplateOutlet="GridLayoutTemplate"></ng-container>
      </div>
    </div>
  </div>
</div>

<div *ngIf="AccordionName == null || AccordionName =='' " [dir]="biService.getDir() ? 'rtl': 'ltr'">

  <ng-container *ngTemplateOutlet="GridLayoutTemplate"></ng-container>
</div>

<ng-template #GridLayoutTemplate>
  <form [formGroup]="formGroup" [dir]="biService.getDir() ? 'rtl': 'ltr'">
    <div class="grid-layout-container" [dir]="biService.getDir() ? 'rtl': 'ltr'">
      <BI-grid-layout [gap]="{ rows: '15px', cols: 5 }"
        class="bi-grid-layout">
        <ng-container *ngFor="let control of controlList" [ngSwitch]="control.controlType">
          <ng-container *ngIf="control.IsVisible">
            

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'title'">
            <BI-grid-layout [rows]="['auto']" [cols]="['auto']" [gap]="3">
              <BI-grid-layout-item [row]="1" [col]="1">
                <h5 class="grid-title m-0">
                  {{
                  control.DisplayName|
                  translate
                  }}
                </h5>
              </BI-grid-layout-item>
            </BI-grid-layout>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'text'">
            <ng-container>
              <BI-grid-layout [rows]="['auto']" [cols]="['100%']" [gap]="3" *ngIf="control.IsVisible">
                <!-- TextAfterInput -->
                <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TextAfterInput">
                  <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
                    <BI-grid-layout-item [row]="1" [col]="1">
                      <ng-container *ngTemplateOutlet="textInput"></ng-container>
                    </BI-grid-layout-item>

                    <BI-grid-layout-item [row]="1" [col]="2">
                      <span class="Text-after-input"> {{ control.TextAfterInput}} </span>
                    </BI-grid-layout-item>
                  </BI-grid-layout>
                </BI-grid-layout-item>

                <!-- TemplateRef -->
                <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TemplateRef">
                  <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
                    <BI-grid-layout-item [row]="1" [col]="1">
                      <ng-container *ngTemplateOutlet="textInput"></ng-container>
                    </BI-grid-layout-item>

                    <BI-grid-layout-item [row]="1" [col]="2">
                      <ng-container [ngTemplateOutlet]="control.TemplateRef">
                      </ng-container>
                    </BI-grid-layout-item>
                  </BI-grid-layout>
                </BI-grid-layout-item>

                <!-- Input only -->
                <BI-grid-layout-item [row]="1" [col]="1" *ngIf="!control.TextAfterInput&&!control.TemplateRef">
                  <ng-container *ngTemplateOutlet="textInput"></ng-container>
                </BI-grid-layout-item>

                <!--  textInput-->
                <ng-template #textInput>
                  <mat-form-field [style]="control.Style" appearance="outline">
                    <mat-label>{{control?.DisplayName ||"" | translate}}</mat-label>
                    <input matInput [formControlName]="control.Name" [id]="'input_'+control.Name" type="text"
                      [mask]="control?.Mask" [showMaskTyped]="control?.Mask? true: false" />
                    <validation-error-tool-tip matSuffix [FormControl]="asFormControl(formGroup.get([control.Name]))"
                      [Control]="control">
                    </validation-error-tool-tip>
                  </mat-form-field>
                </ng-template>
              </BI-grid-layout>
            </ng-container>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'password'">
            <ng-container>
              <BI-grid-layout [rows]="['auto']" [cols]="['100%']" [gap]="3" *ngIf="control.IsVisible">
                <!-- TextAfterInput -->
                <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TextAfterInput">
                  <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
                    <BI-grid-layout-item [row]="1" [col]="1">
                      <ng-container *ngTemplateOutlet="textInput"></ng-container>
                    </BI-grid-layout-item>

                    <BI-grid-layout-item [row]="1" [col]="2">
                      <span class="Text-after-input"> {{ control.TextAfterInput}} </span>
                    </BI-grid-layout-item>
                  </BI-grid-layout>
                </BI-grid-layout-item>

                <!-- TemplateRef -->
                <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TemplateRef">
                  <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
                    <BI-grid-layout-item [row]="1" [col]="1">
                      <ng-container *ngTemplateOutlet="textInput"></ng-container>
                    </BI-grid-layout-item>

                    <BI-grid-layout-item [row]="1" [col]="2">
                      <ng-container [ngTemplateOutlet]="control.TemplateRef">
                      </ng-container>
                    </BI-grid-layout-item>
                  </BI-grid-layout>
                </BI-grid-layout-item>

                <!-- Input only -->
                <BI-grid-layout-item [row]="1" [col]="1" *ngIf="!control.TextAfterInput&&!control.TemplateRef">
                  <ng-container *ngTemplateOutlet="textInput"></ng-container>
                </BI-grid-layout-item>

                <!--  textInput-->
                <ng-template #textInput>
                  <mat-form-field [style]="control.Style" appearance="outline">
                    <mat-label>{{control?.DisplayName ||"" | translate}}</mat-label>
                    <input matInput [formControlName]="control.Name" [id]="'input_'+control.Name" type="password"
                      [mask]="control?.Mask" [showMaskTyped]="control?.Mask? true: false" />
                    <validation-error-tool-tip matSuffix [FormControl]="asFormControl(formGroup.get([control.Name]))"
                      [Control]="control">
                    </validation-error-tool-tip>
                  </mat-form-field>
                </ng-template>
              </BI-grid-layout>
            </ng-container>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'textarea'">
            <ng-container>
              <BI-grid-layout [rows]="['auto']" [cols]="['100%']" [gap]="3" *ngIf="control.IsVisible">
                <bi-floating-text-area [Control]="control" [FormGroup]="formGroup"></bi-floating-text-area>
              </BI-grid-layout>
            </ng-container>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'checkbox'">
            <BI-grid-layout [rows]="['auto']" [cols]="['auto']" [gap]="3" *ngIf="control.IsVisible">
              <BI-grid-layout-item [row]="1" [col]="1" class="check-box">
                <span *ngIf="!control.TemplateRef">
                  <ng-container *ngTemplateOutlet="checkboxInput"></ng-container>
                </span>
                <span class="mx-1" *ngIf="control.TemplateRef">
                  <BI-grid-layout [rows]="['auto']" [cols]="['71%','27%']">
                    <BI-grid-layout-item [row]="1" [col]="1">
                      <ng-container *ngTemplateOutlet="checkboxInput"></ng-container>
                    </BI-grid-layout-item>

                    <BI-grid-layout-item [row]="1" [col]="2">
                      <ng-container [ngTemplateOutlet]="control.TemplateRef">
                      </ng-container>
                    </BI-grid-layout-item>
                  </BI-grid-layout>
                </span>

                <label class="checkbox-label mx-1" [for]="control.Name">
                  {{
                  control.DisplayName
                  |
                  translate
                  }}
                </label>
              </BI-grid-layout-item>

              <ng-template #checkboxInput>
                <input [formControlName]="control.Name" [id]="'input_'+control.Name" type="checkbox"
                  class="form-check-input" />
              </ng-template>

            </BI-grid-layout>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'number'">
            <ng-container>
              <BI-grid-layout [rows]="['auto']" [cols]="['100%']" [gap]="3" *ngIf="control.IsVisible">
                <!-- TextAfterInput -->
                <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TextAfterInput">
                  <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
                    <BI-grid-layout-item [row]="1" [col]="1">
                      <ng-container *ngTemplateOutlet="textInput"></ng-container>
                    </BI-grid-layout-item>

                    <BI-grid-layout-item [row]="1" [col]="2">
                      <span class="Text-after-input"> {{ control.TextAfterInput}} </span>
                    </BI-grid-layout-item>
                  </BI-grid-layout>
                </BI-grid-layout-item>

                <!-- TemplateRef -->
                <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TemplateRef">
                  <BI-grid-layout [rows]="['auto']" [cols]="ColsSizes">
                    <BI-grid-layout-item [row]="1" [col]="1">
                      <ng-container *ngTemplateOutlet="textInput"></ng-container>
                    </BI-grid-layout-item>

                    <BI-grid-layout-item [row]="1" [col]="2">
                      <ng-container [ngTemplateOutlet]="control.TemplateRef">
                      </ng-container>
                    </BI-grid-layout-item>
                  </BI-grid-layout>
                </BI-grid-layout-item>

                <!-- Input only -->
                <BI-grid-layout-item [row]="1" [col]="1" *ngIf="!control.TextAfterInput&&!control.TemplateRef">
                  <ng-container *ngTemplateOutlet="textInput"></ng-container>
                </BI-grid-layout-item>

                <!--  textInput-->
                <ng-template #textInput>
                  <mat-form-field [style]="control.Style" appearance="outline">
                    <mat-label>{{control?.DisplayName ||"" | translate}}</mat-label>
                    <input matInput [formControlName]="control.Name" [id]="'input_'+control.Name" type="number" />
                    <validation-error-tool-tip matSuffix [FormControl]="asFormControl(formGroup.get([control.Name]))"
                      [Control]="control">
                    </validation-error-tool-tip>
                  </mat-form-field>
                </ng-template>
              </BI-grid-layout>
            </ng-container>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'lookup'">
            <BI-grid-layout [rows]="['auto']" [cols]="['100%']" [gap]="3" *ngIf="control.IsVisible">
              <BI-grid-layout-item [row]="1" [col]="1">
                <ng-container *ngTemplateOutlet="lookUp"></ng-container>
              </BI-grid-layout-item>


              <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TemplateRef">
                <BI-grid-layout [rows]="['auto']" [cols]="['71%','27%']">
                  <BI-grid-layout-item [row]="1" [col]="1">
                    <ng-container *ngTemplateOutlet="lookUp"></ng-container>

                  </BI-grid-layout-item>

                  <BI-grid-layout-item [row]="1" [col]="2">
                    <ng-container [ngTemplateOutlet]="control.TemplateRef">
                    </ng-container>
                  </BI-grid-layout-item>
                </BI-grid-layout>
              </BI-grid-layout-item>
              <ng-template #lookUp>
              
                <bi-floating-lookup [DataSource]="control.lookupTemplate?.DataSource" [Control]="control"
                  [BindingProperty]="asFormControl(formGroup.get([control.Name]))" [Key]="control.lookupTemplate?.Key"
                  [DomID]="'input_' + control.Name" [Title]="control.lookupTemplate?.Title || control.DisplayName"
                  [style]="control.Style" [Lookuptemplet]="control?.lookupTemplate"
                  [hasSelection]="control?.lookupTemplate?.hasSelection"
                  [Description]="control.lookupTemplate?.Description" [route]="control.lookupTemplate?.route"
                  [hasPendingChanges]="hasPendingChanges" [DataType]="control.DataType"
                  (AfterLoad)="control?.lookupTemplate?.AfterLoad && control?.lookupTemplate?.AfterLoad()"
                  (BeforeLoad)="control?.lookupTemplate?.BeforeLoad && control?.lookupTemplate?.BeforeLoad()"
                  (OnClose)="control?.lookupTemplate?.OnClose && control?.lookupTemplate?.OnClose()"
                  (OnOpen)="control?.lookupTemplate?.OnOpen && control?.lookupTemplate?.OnOpen()"
                  (ReturnedValueEmitter)="control?.lookupTemplate?.ReturnedValueEmitter && control?.lookupTemplate?.ReturnedValueEmitter($event)">
                </bi-floating-lookup>

              </ng-template>

            </BI-grid-layout>

          </BI-grid-layout-item>


          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'select'">
            <BI-grid-layout [rows]="['auto']" [cols]="['auto']" [gap]="3" *ngIf="control.IsVisible">

              <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TextAfterInput">
                <BI-grid-layout [rows]="['auto']" [cols]="['71%','27%']">
                  <BI-grid-layout-item [row]="1" [col]="1">
                    <ng-container *ngTemplateOutlet="dropdown"></ng-container>
                  </BI-grid-layout-item>

                  <BI-grid-layout-item [row]="1" [col]="2">
                    <span class="Text-after-input"> {{ control.TextAfterInput}} </span>
                  </BI-grid-layout-item>
                </BI-grid-layout>
              </BI-grid-layout-item>


              <BI-grid-layout-item [row]="1" [col]="1" *ngIf="control.TemplateRef">
                <BI-grid-layout [rows]="['auto']" [cols]="['71%','27%']">
                  <BI-grid-layout-item [row]="1" [col]="1">
                    <ng-container *ngTemplateOutlet="dropdown"></ng-container>
                  </BI-grid-layout-item>

                  <BI-grid-layout-item [row]="1" [col]="2">
                    <ng-container [ngTemplateOutlet]="control.TemplateRef">
                    </ng-container>
                  </BI-grid-layout-item>
                </BI-grid-layout>
              </BI-grid-layout-item>


              <BI-grid-layout-item [row]="1" [col]=" 1" *ngIf="!control.TextAfterInput&&!control.TemplateRef">
                <ng-container *ngTemplateOutlet="dropdown"></ng-container>
              </BI-grid-layout-item>

              <ng-template #dropdown>
                <bi-floating-drop-down [Control]="control"
                  [BindingProperty]="asFormControl(formGroup.get([control.Name]))" [Label]="control?.DisplayName "
                  [DropDownList]="control.dropDownTemplate?.list" [ValueField]="control.dropDownTemplate?.value"
                  [TextField]="control.dropDownTemplate?.text" [style]="control.Style" [styleType]="'large'"
                  [IsDisabled]="!control.IsEditable" [DomId]="'input_'+control.Name"
                  [IsFilterable]="control.dropDownTemplate?.IsFilterable || false"
                  (OnselectionChange)="control.dropDownTemplate?.OnselectionChange && control.dropDownTemplate?.OnselectionChange($event)"
                  (OnValueChange)="control.dropDownTemplate?.OnValueChange && control.dropDownTemplate?.OnValueChange($event)">
                </bi-floating-drop-down>
              </ng-template>

            </BI-grid-layout>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'datetime'">
            <mat-form-field appearance="outline">
              <mat-label>{{control.DisplayName|translate}}</mat-label>
              <input matInput [ngxMatDatetimePicker]="picker" [formControl]="asFormControl(formGroup.get([control.Name]))"
                [min]="minDate" [max]="maxDate" [disabled]="disabled">
              <mat-datepicker-toggle matSuffix [for]="$any(picker)"></mat-datepicker-toggle>
              <ngx-mat-datetime-picker #picker [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond" [touchUi]="touchUi"
                [enableMeridian]="enableMeridian">
              </ngx-mat-datetime-picker>
            </mat-form-field>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'date'">
            <ng-container *ngIf="control.IsVisible">
              <mat-form-field [style]="control.Style" appearance="outline">
                <mat-label>{{control.DisplayName|translate}}</mat-label>
                <input matInput [matDatepicker]="picker" [formControl]="asFormControl(formGroup.get([control.Name]))" />
                <span matSuffix class="date-validation">
                  <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <validation-error-tool-tip [FormControl]="asFormControl(formGroup.get([control.Name]))"
                    [Control]="control" [ControlType]="'date'">
                  </validation-error-tool-tip>
                </span>
              </mat-form-field>
            </ng-container>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'time'">
            <mat-form-field appearance="outline">
              <mat-label>{{control?.DisplayName ||"" | translate}}</mat-label>
              <input matInput id="time-input" value="null" [formControlName]="control.Name" [id]="'input_'+control.Name"
                type="time" />

              <validation-error-tool-tip matSuffix [FormControl]="asFormControl(formGroup.get([control.Name]))"
                [Control]="control">
              </validation-error-tool-tip>
            </mat-form-field>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'color'">
            <BI-grid-layout [rows]="['auto']" [cols]="['100%']" [gap]="3">
              <BI-grid-layout-item [row]="1" [col]="1">
                <bi-floating-color-picker [FormControl]="asFormControl(formGroup.get([control.Name]))"
                  [Control]="control"></bi-floating-color-picker>
              </BI-grid-layout-item>
            </BI-grid-layout>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'logText'">
            <ng-container>
              <BI-grid-layout [rows]="['auto']" [cols]="['100%']" [gap]="3" *ngIf="control.IsVisible">
                <bi-floating-text-area [Control]="control" [FormGroup]="formGroup"></bi-floating-text-area>
              </BI-grid-layout>
            </ng-container>
          </BI-grid-layout-item>

          <BI-grid-layout-item [col]="control.colNumber" class="hyperlink"  [row]="control.rowNumber" *ngSwitchCase="'HyperLink'">
            <ng-container>
              <BI-grid-layout [rows]="['auto']" [cols]="['100%']" [gap]="3" *ngIf="control.IsVisible">
                <a [href]="control.HyperLink" class="hyperlink" target="_self">{{control.DisplayName |
                  translate}}</a>
              </BI-grid-layout>
            </ng-container>
          </BI-grid-layout-item>


          <BI-grid-layout-item [col]="control.colNumber" [row]="control.rowNumber" *ngSwitchCase="'template'">
            <ng-container *ngIf="control.TemplateRef && control?.IsVisible">

              <ng-container [ngTemplateOutlet]="control.TemplateRef">
              </ng-container>

            </ng-container>

          </BI-grid-layout-item>

          </ng-container>
        </ng-container>
      </BI-grid-layout>
    </div>
  </form>
</ng-template>